import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { GLH_APPLICATIONS } from "@app/portals/glh-modules/glh-shared/constants/applications.constants";
import { GLH_PORTALS } from "@app/portals/glh-modules/glh-shared/constants/portal-constants";

export const GlhGuard = () => {
  const authService = inject(AuthenticationService);

  // Check for valid application and portal
  const application = authService.applicationId === GLH_APPLICATIONS.GROUP;
  const portal = [GLH_PORTALS.GROUP, GLH_PORTALS.AGENT, GLH_PORTALS.MEMBER].includes(authService.moduleId);

  if (!application || !portal) {
    return false;
  }

  return true;
};
